import { Option } from './Combobox.mjs';

const ComboboxOption = Option;

export { ComboboxOption };
